

import { AlertController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { HttpClient } from '@angular/common/http';

interface AudioTextHistory {
  Text: string;
  Username: string;
  Gender: string;
  Age: string;
  Accent: string;
  Language: string;
  Type: string;
  AudioPath: string;
}

@Component({
  selector: 'app-stt-inferenced-history',
  templateUrl: './stt-inferenced-history.component.html',
  styleUrls: ['./stt-inferenced-history.component.scss'],
})
export class SttInferencedHistoryComponent  implements OnInit {
  @Input() initiator:string = "";
  @Input() currentTextIdForHistory:string = "";
  @Input() currentUserIdForHistory:string = "";
  @Input() showDataOf:string = "";
  @Input() selectedOptionLang:string = "";
  historyData: any[] = [];

  numberOfOwnDataDelete:number = 0;
  numberOfAllsDataDelete:number = 0;
  totalPages: number = 1; // Initialize totalPages to 1
  
  constructor(private modalCtrl: ModalController,private apiService:ApiService,private router:Router,private globalService:GlobalService,private http: HttpClient,private alertController: AlertController) {
   

  }
  ngOnInit(){
    console.log("this.currentTextIdForHistory is:",this.currentTextIdForHistory);
    console.log("this.showData of:",this.showDataOf);

    this.fetchInferencedHistory(this.currentTextIdForHistory,this.showDataOf,this.selectedOptionLang,this.currentUserIdForHistory);
  }

  normalizeText(text: string): string {
    return text?.toLowerCase().replace(/[^\w\s]|_/g, '').replace(/\s+/g, ' ').trim();
  }

  isTextMatched(original: string, transcribed: string): boolean {
    return this.normalizeText(original) === this.normalizeText(transcribed);
  }



  fetchInferencedHistory(currentTextIdForHistory: string,showDataOf:string, selectedOptionLang: string, currentUserIdForHistory: string) {
      console.log("fetch the history");
      this.globalService.logoutLoading();
      
      try {
        const lang = selectedOptionLang || localStorage.getItem('langCategory') || 'nl'; // Default to 'nl' if not set
        const current_page =  '1';
        const page_size =  '10';
        const text = currentTextIdForHistory;
        const current_user_id = currentUserIdForHistory;
        const user = showDataOf;


        this.apiService.getSTTInferenceSavedData(lang,current_page, page_size,user,text,current_user_id).subscribe({
        next: (response) => {
          try {
            if (response?.data) {
              this.historyData = response.data;
              // console.log("FFFFetched history data:", this.historyData);
              this.totalPages = 1;
            } else {
              console.error("Invalid response format: Missing 'data' key", response);
              this.historyData = [];
              this.totalPages = 1;
            }
          } catch (processingError) {
            console.error("Error while processing response:", processingError);
            this.historyData = [];
            this.totalPages = 1;
          } finally {
            this.globalService.dismissLoading(); // Hide loading indicator
          }
        },
        error: (err) => {
          console.error("API call failed:", err);
          this.historyData = [];
          // this.totalPages = 1;
          this.globalService.dismissLoading(); // Hide loading on error
        }
      });

        
      } catch (error) {
        console.error("Error in fetchInferencedHistory:", error);
      }

      

      
    

  }


  deleteData(item:any){
    this.showDeleteAlert(item);

  }

  updateRowValueOnDelete(guid: string) {
    this.historyData = this.historyData.filter(row => row.guid !== guid);
  }

  async showDeleteAlert(item: any) {
    console.log("11111ttttttttttext has been deleted",item);
    const guid = item.guid; // Assuming 'item' has a 'guid' property
    const alert = await this.alertController.create({
      header: 'Confirm Deletion',
      message: `Are you sure you want to delete?`,
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Delete',
          handler: async () => {
            this.apiService.deleteSTTInferencedData(guid).subscribe(
              async (response) => {
                console.log("Text has been deleted successfully.");
                // this.fetchTextList(); //teporarily added when updated call api to refresh
                this.updateRowValueOnDelete(guid);

                if (item.userid === localStorage.getItem('userId')) {
                  this.numberOfOwnDataDelete++;
                  this.numberOfAllsDataDelete++;
                }else{
                  this.numberOfAllsDataDelete++;
                }


              },
              (err) => {
                console.error("Error during delete API call:", err);
              }
            );
          }
        }
      ]
    });
  
    await alert.present();
  }





  goToMenu() {
    this.router.navigate(['/menu']);
  }


  closeModal(target: string) {
    const data = {
      numberOfAllsDataDelete: this.numberOfAllsDataDelete !== 0 ? this.numberOfAllsDataDelete : 0,
      numberOfOwnDataDelete: this.numberOfOwnDataDelete !== 0 ? this.numberOfOwnDataDelete : 0
    };
  
    this.modalCtrl.dismiss(data);
  }
  

}
